import {AuthConfig} from '../message/AuthConfig';
import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {BasicCriteria} from '../../../allkey/framework/parameters/BasicCriteria';
import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';

export class AuthConfigWrapper extends BaseWrapper<AuthConfig, BasicCriteria, BasicScenario>  {}

